var plugin_rtlignore_default = {
  "alignLeft": "vuUph",
  "textWrapNowrap": "POAnb",
  "alignRight": "_6mBFr",
  "alignCenter": "zc6hD",
  "sizeFullWidth": "k9j7F",
  "renderedInTable": "vQJEm",
  "sizeOriginal": "fcYAE",
  "sizeContent": "TPfi2",
  "sizeSmall": "bX1Z8",
  "sizeSmallCenter": "TSedi",
  "flex": "_1Z5c4",
  "atomic": "_3pLto",
  "embed": "CI-CS",
  "horizontalScrollbar": "ejWuE",
  "pluginContainerMobile": "c3-mS"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
